/**
 * Universal store buy-gate decision, shared across entity pages.
 *
 * 1. Already has access -> never show Buy, regardless of available_for.
 * 2. No access, available_for is a real non-empty list -> show Buy only if
 *    the user's subscription type is on it.
 * 3. No access, available_for missing/empty -> show Buy (today's default,
 *    unrestricted — protects content that hasn't been migrated to this field).
 */
export const resolveShowBuy = (
  hasAccess,
  availableFor,
  userSubscriptionType
) => {
  if (hasAccess) return false;

  const isListPopulated =
    Array.isArray(availableFor) && availableFor.length > 0;
  if (!isListPopulated) return true;

  return availableFor.includes(userSubscriptionType);
};

export default resolveShowBuy;
